import React, { useState } from 'react';
import { WebLinkBase } from 'platform-specific/link';
import { UtilityText } from 'component/text';
import { component, demoFile, story, CLICK, CHECK_TEXT } from 'system/demo';

demoFile('component/weblink');

function WebLinkBaseDemo() {
    const [pressed, setPressed] = useState(false);
    return (
        <>
            <WebLinkBase testID='open-link' url='https://example.com' style={undefined} onLinkPress={() => setPressed(true)}>
                <UtilityText text='Open' />
            </WebLinkBase>
            {pressed && <span>Pressed</span>}
        </>
    );
}

component('WebLinkBase', WebLinkBaseDemo, {}, [
    story('Press', [CLICK('open-link'), CHECK_TEXT('Pressed')])
]);
